export const rolesPermissionsData = [
  {
    roleName: 'Admin',
    createdOn: '27 Mar 2024',
    key: 1,
  },
  {
    roleName: 'Player',
    createdOn: '20 Mar 2024',
    key: 2,
  },
  {
    roleName: 'Parent',
    createdOn: '16 Mar 2024',
    key: 3,
  },
  {
    roleName: 'Guardian',
    createdOn: '26 Feb 2024',
    key: 4,
  },
  {
    roleName: 'Coach',
    createdOn: '21 Jan 2024',
    key: 8,
  },
];
